import { Directive, Injectable } from '@angular/core';
import { MetabaseApiService, MetabaseCardCollection } from './metabase-report-api.service';
import { ExceljsApiService, ExceljsCardCollection } from './exceljs-report-api.service';
import { ApiService, IApiOption } from '@red/api';
import { IQuerySearch } from '@shared/data-access/interfaces';
import { Observable, map } from 'rxjs';
import { PaginationAdapter } from '@red/data-access';
import { ReportCard } from '@shared/components/report-manager';
import { Mixin } from 'ts-mixer';
@Directive()
abstract class SupplierReportMetabaseApiService extends MetabaseApiService {
  collection: MetabaseCardCollection = 'supplier_reports';
}

@Directive()
abstract class SupplierReportExceljsApiService extends ExceljsApiService {
  collectionEndpoint = ExceljsCardCollection.SupplierReport;
}
@Directive()
abstract class SupplierReportCardApiService {
  static REPORT_CARD_POINT = 'finance/suppliers/reports';
  constructor(protected apiService: ApiService) {}

  findReportCards(query: IQuerySearch = {}, option?: IApiOption): Observable<PaginationAdapter<ReportCard>> {
    return this.apiService.get(SupplierReportCardApiService.REPORT_CARD_POINT, query, option).pipe(map(data => new PaginationAdapter(ReportCard, data)));
  }
}

@Injectable({
  providedIn: 'root',
})
export class SupplierReportApiService extends Mixin(SupplierReportCardApiService, SupplierReportMetabaseApiService, SupplierReportExceljsApiService) {}
